/** System note prefixes — matching Angular isSystemNote() patterns. Cannot be edited. */
export const SYSTEM_NOTE_PREFIXES = [
  'Email',
  'Account',
  'Lease',
  'Rent',
  'Checkin',
  'Checkout',
  'Application',
  'User account',
  'Finance Manager',
  'Risk Rating changed',
  'Moved from',
  'Moved to',
  'Property',
  'Company',
  'Underwriting',
  'Insurance',
  'Payment',
  'Reimbursement',
  'Certificate',
  'Default',
  'Claim',
  'Product',
  'Stock',
  'Transfer',
  'Merge',
  'Split',
  'Swap',
  'Pre-qualification',
] as const

export type UserManagementEditConfirmKind =
  | 'temp-password'
  | 'account-toggle'
  | 'reset-password'
  | 'remove-role-only-one'
  | 'remove-role'
  | 'fin-mgr'
  | 'sales-role'
  | 'sales-role-assigned'
  | 'sales-role-unassigned'
  | 'impersonate'
